import React, { createContext, useContext,  useReducer } from "react";
import { parksViewReducer } from "../reducers/parksViewReducer";
import {initialSummary, initialFilterSafariPackagesParkWise } from "Data/safariPackages";
import { initialFilterSharedSafariPark } from "Data/sharedSafari";


//Create context
export const ParksViewContext = createContext();

//Initial state
const initialState = {
    parkDetail: null,
    parkViewLoading: true,
    parkViewError: '',
    //Park wise Packages
    parkWisePackages: [],
    packageSummary: initialSummary,
    filters: initialFilterSafariPackagesParkWise,
    pageIndex: 1,
    //park wise Safaries
    parkSharedSafariData: [],
    safariSummary: initialSummary,
    safariFilters: initialFilterSharedSafariPark,
    safariPageIndex: 1,
    //park Review
    parkReviewData:[],
    parkViewReviewModalToggle: false,
    suggCorrToggle: false,
};

//Provider
const ParksViewProvider = ({ children }) => {
    const [parksViewState, parksViewDispatch] = useReducer(parksViewReducer, initialState);
 


    return (
        <ParksViewContext.Provider
            value={{
                ...parksViewState,
                parksViewDispatch,
            }}
        >
            {children}
        </ParksViewContext.Provider>
    );
};

//hook
export const useParksViewContext = () => useContext(ParksViewContext);

export default ParksViewProvider;
